"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@opentelemetry/api");
const configuration_1 = require("../configuration");
const originalGetMeter = api_1.metrics.getMeter;
api_1.metrics.getMeter = (serviceName, serviceVersion) => {
    var _a, _b;
    if (configuration_1.Configuration.isSdkStarted) {
        const configuration = configuration_1.Configuration.instance;
        if (!serviceName) {
            serviceName = configuration.serviceName;
        }
        if (!serviceVersion) {
            serviceVersion = configuration.serviceVersion;
        }
    }
    if (!serviceName) {
        serviceName = ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.SERVICE_NAME) || ((_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b.OTEL_SERVICE_NAME) || '{{SERVICE_NAME}}';
    }
    return originalGetMeter.call(api_1.metrics, serviceName, serviceVersion);
};
exports.default = api_1.metrics;
//# sourceMappingURL=metrics.js.map